import { Component } from '@angular/core';
import { RecorderStore } from '../../stores/recorder.store';
import { TimelineStore } from '../timeline.store';

@Component({
  selector: 'app-timeline-layer-add',
  templateUrl: './timeline-layer-add.component.html',
  styleUrls: ['./timeline-layer-add.component.styl']
})
export class TimelineLayerAddComponent {
  constructor(
    private recorderStore: RecorderStore,
    private timelineStore: TimelineStore,
  ) {
  }

  onButtonClick() {
    this.addLayer();
  }

  addLayer() {
    this.recorderStore.addLayer()
      .then(() => this.timelineStore.selectLastLayer());
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer-add/timeline-layer-add.component.ts